// @flow
import { Typography } from '@mui/material'
import Box from '@mui/material/Box'
import Grid from "@mui/material/Grid2";
import { useTheme } from '@mui/material/styles'

type Props = {
	label: string
};

const CardFieldInfo = (props: Props) => {
	const { label, sx = {} } = props
	return (
		<Box sx={{display: 'flex'}}>
			<Box>
				<Typography
					variant={'body1'}
					component={'div'}
					sx={{ fontWeight: 'bold', paddingRight: 1, minWidth: '100px'}}
				>
					{label}
				</Typography>
			</Box>
			<Box sx={{ alignSelf: 'end',  wordWrap: 'break-word', ...sx }}>
				<Typography
					variant={'body1'}
					component={'div'}
				>
					{props.children}
				</Typography>
			</Box>
			
		</Box>
	)
}

export default CardFieldInfo